import { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";
import eventsAPI from "../api/eventsAPI";
import { useLocation } from "react-router-dom";
import useFormFilledCalc from "../hooks/useFormFilledCalc";
import { toast } from "react-toastify";
import {
  addDays,
  differenceInCalendarDays,
  startOfDay,
  endOfDay,
} from "date-fns";

const EventContext = createContext();

export const useEvent = () => useContext(EventContext);

// Provides the event context to all components in the application.
// Its includes the event data, form data, and functions to handle the form data.
// It is used to share the event data between components.
// It is also used to handle the form submission and update the event data.
// It is used to show the loading state of the application.
// It is used to manage the visibility of the forms and the modal.
// It is used to manage the percentage of the form filled.
// It is used to manage the selected event data.
// It is used to fetch the event details and update the event data.
// It is used to manage the visibility of the delete button.
export const EventProvider = ({ children }) => {
  // store the event data in the context
  // eslint-disable-next-line
  const { user, setUser } = useAuth();
  const [formData, setFormData] = useState({
    event_name: "",
    event_type: "",
    organized_by: "",
    description: "",
    eventDuration: [],
    // start_date: null,
    start_time: null,
    // end_date: null,
    end_time: null,
    registration_start_date: null,
    registration_start_time: null,
    location: "",
    venue_type: "",
    image_url: null,
    capacity: "",
    organizerID: user?.id,
    mainEventID: "",
  });

  const location = useLocation();

  // store the mainEvent id in state
  const [mainEventID, setMainEventID] = useState(null);

  // logic of button onclick and onchange
  const [isFormVisible, setIsFormVisible] = useState(false);
  //   const handleAddSpace = () => {
  //     setIsFormVisible(true);
  //   };

  //   Handles the change event of any input field in the event form.
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //   handle the visiblity of the saved event data
  const [eventCreated, setEventCreated] = useState(false);
  const [locationAdded, setLocationAdded] = useState(false);
  const [speakerAdded, setSpeakerAdded] = useState(false);
  const [TypeAdded, setTypeAdded] = useState(false);
  const [sponsorAdded, setSponsorAdded] = useState(false);
  const [stallAdded, setStallAdded] = useState(false);
  const [subEventAdded, setSubEventAdded] = useState(false);

  // edit function and add multiple location
  const [locations, setLocations] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  // edit function and add multiple registration types
  const [types, setTypes] = useState([]);
  const [typeEditIndex, setTypeEditIndex] = useState(null);

  //   const handleTypeEdit = (index) => {
  //     setLocationFormData(types[index]);
  //     setIsFormVisible(true);
  //     setTypeEditIndex(index);
  //   };

  // edit function and add multiple speakers
  const [speakers, setSpeakers] = useState([]);
  const [speakerEditIndex, setSpeakerEditIndex] = useState(null);

  //   const handleSpeakerEdit = (index) => {
  //     setLocationFormData(speakers[index]);
  //     setIsFormVisible(true);
  //     setSpeakerEditIndex(index);
  //   };

  // edit function and add multiple sponsors
  const [sponsors, setSponsors] = useState([]);
  const [sponsorEditIndex, setSponsorEditIndex] = useState(null);

  //   const handleSponsorEdit = (index) => {
  //     setLocationFormData(sponsors[index]);
  //     setIsFormVisible(true);
  //     setSponsorEditIndex(index);
  //   };

  // edit function and add multiple stalls
  const [stalls, setStalls] = useState([]);
  const [stallEditIndex, setStallEditIndex] = useState(null);

  //   const handleStallEdit = (index) => {
  //     setStallFormData(sponsors[index]);
  //     setIsFormVisible(true);
  //     setStallEditIndex(index);
  //   };

  // edit function and add multiple subEvents
  const [subEvents, setSubEvents] = useState([]);
  const [subEventEditIndex, setSubEventEditIndex] = useState(null);

  //   const handleSubEdit = (index) => {
  //     setSubEventFormData(subEvents[index]);
  //     setIsFormVisible(true);
  //     setSubEventEditIndex(index);
  //   };

  // loading states for handle the button visibility
  const [loading, setLoading] = useState(false);

  // store location details in context
  const [LocationformData, setLocationFormData] = useState({
    space_name: "",
    space_code: "",
    space_type: "",
    space_capacity: "",
    space_address: "",
    mainEventID: "",
  });

  const handleLocationChange = (e) => {
    const { name, value } = e.target;
    setLocationFormData({
      ...LocationformData,
      [name]: value,
    });
  };

  // store sub Event data in context

  const [subEventFormData, setSubEventFormData] = useState({
    title: "",
    event_type: "",
    location: "",
    start: null,
    end: null,
    description: "",
    speakers: [],
    sponsors: [],
    registration_types: [],
    isOpen: "",
    mainEventID: "",
  });

  const handleSubChange = (e) => {
    const { name, value } = e.target;
    setSubEventFormData({
      ...subEventFormData,
      [name]: value,
    });
  };

  // store register types data in context

  const [registrationFormData, setRegistraionFormData] = useState({
    typeName: "",
    price: "",
    description: "",
    mainEventID: "",
  });

  const handleRegisterChange = (e) => {
    const { name, value } = e.target;
    setRegistraionFormData({
      ...registrationFormData,
      [name]: value,
    });
  };

  // store Speakers details in context
  const [speakerFormData, setSpeakerFormData] = useState({
    speaker_name: "",
    speaker_type: "",
    image_url: "",
    company_name: "",
    social_links: "",
    mainEventID: "",
  });

  const handleSpeakerChange = (e) => {
    const { name, value } = e.target;
    setSpeakerFormData({
      ...speakerFormData,
      [name]: value,
    });
  };

  // store meeting details in context
  const [meetingFormData, setMeetingFormData] = useState({
    agenda: "",
    locationID: "",
    start: null,
    end: null,
    invited: [],
    mainEventID: "",
  });

  // store Sponsor details in context
  const [SponsorformData, setSponsorFormData] = useState({
    company_name: "",
    sponsor_type: "",
    company_banner: "",
    company_logo: "",
    mainEventID: "",
  });

  const handleSponsorChange = (e) => {
    const { name, value } = e.target;
    setSponsorFormData({
      ...SponsorformData,
      [name]: value,
    });
  };

  // store stall details in context
  const [stallFormData, setStallFormData] = useState({
    stall_name: "",
    stall_type: "",
    registration_type: "",
    stall_size_length: "",
    stall_size_width: "",
    stall_price: "",
    number_of_stalls: "",
    number_of_stall_booked: "",
    mainEventID: "",
  });

  const handleStallChange = (e) => {
    const { name, value } = e.target;
    setStallFormData({
      ...stallFormData,
      [name]: value,
    });
  };

  // formate date and time Function
  const formattedDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const formattedTime = (timeString) => {
    const date = new Date(timeString);
    const time = date.toLocaleTimeString();

    return `${time}`;
  };

  // store selected event data
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [loadingEvents, setLoadingEvents] = useState({});
  const [meetingAdded, setMeetingAdded] = useState(false);
  const [registrationData, setRegistrationData] = useState([]);

  //   Fetches event details from the server and stores it in the context
  const fetchEventDetails = async (eventId, isOrganizer) => {
    try {
      setLoadingEvents((prev) => ({ ...prev, [eventId]: true }));
      const response = await eventsAPI.get(`/data/details?eventID=${eventId}`);
      setLoadingEvents((prev) => ({ ...prev, [eventId]: false }));
      //   console.log(response.data);
      if (isOrganizer) {
        // console.log(response.data);
        // Check if response.data[0] exists and set formData
        if (response.data[0]) {
          setFormData({
            ...response.data[0],
            mainEventID: response.data[0]._id,
          });
        }

        // Check if locations exist in response and set appropriate state
        if (response.data[1] && response.data[1].length > 0) {
          setLocations(response.data[1]);
          setLocationAdded(true);
        } else {
          setLocationAdded(false);
        }

        // Check if speakers exist in response and set appropriate state
        if (response.data[2] && response.data[2].length > 0) {
          setSpeakers(response.data[2]);
          setSpeakerAdded(true);
        } else {
          setSpeakerAdded(false);
        }

        // Check if types exist in response and set appropriate state
        if (response.data[3] && response.data[3].length > 0) {
          setTypes(response.data[3]);
          setTypeAdded(true);
        } else {
          setTypeAdded(false);
        }

        // Check if sponsors exist in response and set appropriate state
        if (response.data[4] && response.data[4].length > 0) {
          setSponsors(response.data[4]);
          setSponsorAdded(true);
        } else {
          setSponsorAdded(false);
        }

        // Check if stalls exist in response and set appropriate state
        if (response.data[5] && response.data[5].length > 0) {
          setStalls(response.data[5]);
          setStallAdded(true);
        } else {
          setStallAdded(false);
        }

        // Check if registration data exist in response and set appropriate state
        if (response.data[6] && response.data[6].length > 0) {
          setRegistrationData(response.data[6]);
        }

        // Check if sub-events exist in response and set appropriate state
        if (response.data[7] && response.data[7].length > 0) {
          setSubEvents(response.data[7]);
          setSubEventAdded(true);
        } else {
          setSubEventAdded(false);
        }
      } else {
        setSelectedEvent(response.data);
        setMeetingAdded(true);
      }
    } catch (error) {
      console.log("Error fetching event details:", error);
    }
  };

  // state to display how much percentage form filled.
  const {
    calculateProfileFormFilledPercentage,
    calculateMainEventFormFilledPercentage,
  } = useFormFilledCalc();
  const [mainEventFormFilledPercentage, setMainEventFormFilledPercentage] =
    useState(
      calculateMainEventFormFilledPercentage(formData?.image_url, formData)
    );
  const [profileFormFilledPercentage, setProfileFormFilledPercentage] =
    useState(calculateProfileFormFilledPercentage(user?.profilePicture, user));

  useEffect(() => {
    setProfileFormFilledPercentage(
      calculateProfileFormFilledPercentage(user?.profilePicture, user)
    );
    // Ensure formData is not null before calculating percentage
    if (formData) {
      setMainEventFormFilledPercentage(
        calculateMainEventFormFilledPercentage(formData?.image_url, formData)
      );
    }
    // eslint-disable-next-line
  }, [user, formData]);

  // reset the all forms when user redirected to home page
  const resetForm = () => {
    setFormData({
      event_name: "",
      event_type: "",
      description: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      registration_start_date: "",
      registration_start_time: "",
      location: "",
      venue_type: "",
      image_url: "",
      capacity: "",
      organizerID: user?.id,
      mainEventID: "",
    });
    setLocationFormData({
      space_name: "",
      space_code: "",
      space_type: "",
      space_capacity: "",
      space_address: "",
      mainEventID: "",
    });
    setRegistraionFormData({
      typeName: "",
      price: "",
      description: "",
      mainEventID: "",
    });
    setSpeakerFormData({
      speaker_name: "",
      speaker_type: "",
      image_url: "",
      company_name: "",
      social_links: "",
      mainEventID: "",
    });
    setSponsorFormData({
      company_name: "",
      sponsor_type: "",
      company_banner: "",
      company_logo: "",
      mainEventID: "",
    });
    setStallFormData({
      stall_name: "",
      stall_type: "",
      registration_type: "",
      stall_size_length: "",
      stall_size_width: "",
      stall_price: "",
      number_of_stalls: "",
      number_of_stall_booked: "",
      mainEventID: "",
    });
    setSubEventFormData({
      title: "",
      event_type: "",
      location: "",
      start: null,
      end: null,
      description: "",
      speakers: [],
      sponsors: [],
      registration_types: [],
      isOpen: "",
      mainEventID: "",
    });
    setEventCreated(false);
    setLocationAdded(false);
    setSpeakerAdded(false);
    setTypeAdded(false);
    setSponsorAdded(false);
    setStallAdded(false);
    setSubEventAdded(false);
    setIsFormVisible(false);
    setMainEventID(null);
  };

  useEffect(() => {
    if (location.pathname.split("/")[1] === "organizerdashboard") {
      setMainEventID(formData?.mainEventID);
    } else {
      resetForm();
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  //   useEffect(() => {
  //     if (location.pathname.split("/")[1] !== "organizerdashboard") {
  //       resetForm();
  //     }
  //     // eslint-disable-next-line
  //   }, [location.pathname]);

  //   modal visibility logic
  const [isModalOpen, setIsModalOpen] = useState(false);

  // state store registered Events data
  const [registeredEvents, setRegisteredEvents] = useState([]);

  //   const navigate = useNavigate();

  // Fetch registered events when the component loads
  useEffect(() => {
    const fetchRegisteredEvents = async () => {
      try {
        // Check if the user ID is available before making the API call
        if (user?.id) {
          const response = await eventsAPI.get(
            `/data/userRegistered?userID=${user?.id}`
          );

          if (response.status === 200) {
            setRegisteredEvents(response.data);
          } else {
            toast.error("Failed to load registered events");
          }
        }
      } catch (error) {
        toast.error("Error loading events");
        console.log("Error fetching registered events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRegisteredEvents();
    // eslint-disable-next-line
  }, [user?.id]);

  // calender handleSelectSlot function

  const [newEvent, setNewEvent] = useState(null); // To store the new event being created
  const [view, setView] = useState("month");
  const [selectedDate, setSelectedDate] = useState(null);
  const [isSubModalOpen, setIsSubModalOpen] = useState(false); // Modal visibility state

  const handleSelectSlot = (slotInfo) => {
    if (!slotInfo.start || !slotInfo.end) return;

    const startDateTime = new Date(slotInfo.start);
    let endDateTime = new Date(slotInfo.end);

    // If the end time is exactly midnight, set it to the end of the previous day
    if (endDateTime.getHours() === 0 && endDateTime.getMinutes() === 0) {
      endDateTime = new Date(endDateTime.getTime() - 1); // Subtract 1 ms to include the entire day
    }

    const rangeStart = new Date(formData.eventDuration[0].start);
    const rangeEnd = new Date(
      formData.eventDuration[formData.eventDuration.length - 1].end
    );

    // Normalize range dates for comparison
    rangeStart.setHours(0, 0, 0, 0); // Start of the first day
    rangeEnd.setHours(23, 59, 59, 999); // End of the last day

    // Adjusted range check: compare dates only to include entire days
    if (startDateTime < rangeStart || endDateTime > rangeEnd) {
      //   console.log("out of range"); // Ignore selection if out of range
      return;
    }
    setNewEvent({ start: startDateTime, end: endDateTime, title: "" });
    setView("day");
    setSelectedDate(startDateTime);

    if (view === "day") {
      setIsSubModalOpen(true);
    }

    setSubEventFormData({
      ...subEventFormData,
      start: startDateTime,
      end: endDateTime,
    });
  };

  // store accepted and rejected invitation
  const [acceptedInvitations, setAcceptedInvitations] = useState([]); // Store accepted invitations
  const [rejectedInvitations, setRejectedInvitations] = useState([]); // Store accepted invitations

  // user profile section data connection request handle part

  const [selectedUser, setSelectedUser] = useState(null);

  // function to handle connection request

  const handleConnect = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await eventsAPI.post("/data/connect", {
        senderId: user.id,
        receiverId: selectedUser._id,
      });
      if (response.status === 200) {
        if (response.data.message === "Connection request already sent") {
          toast.info("You have already sent a connection request.");
          //   setConnSent(true);
          setLoading(false);
        } else if (response.data.message === "Receiver already invited") {
          toast.info("This user has already been invited.");
          setLoading(false);
        } else {
          toast.success("Connection request sent successfully.");
          setLoading(false);
        }
      } else {
        toast.error("Failed to send connection request.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
      setLoading(false);
      console.log(error);
    }
  };

  // function for fetch connection status from backend

  const [connStatus, setConnStatus] = useState(null); // Connection status from the backend

  const fetchConnectionStatus = async (receiverId) => {
    setLoading(true);
    try {
      const response = await eventsAPI.post("/data/connectionStatus", {
        senderId: user.id,
        receiverId,
      });

      if (response.status === 200) {
        setConnStatus(response.data.status); // Set the status (pending, accepted, rejected)
        // setConnSent(true); // Mark as connection sent
      } else {
        setConnStatus(null); // Reset if no connection exists
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  //store event duration objects

  const [eventDuration, setEventDuration] = useState([]); // Array to store event duration
  const [allSelected, setAllSelected] = useState(() => {
    return formData.eventDuration.every((day) => day.selected); // Track the state of "select all" checkbox
  });

  const [startDate, setStartDate] = useState(
    formData?.eventDuration?.[0]?.start
      ? new Date(formData?.eventDuration[0].start)
      : null
  );
  const [endDate, setEndDate] = useState(
    formData?.eventDuration?.[formData?.eventDuration?.length - 1]?.end
      ? new Date(
          formData?.eventDuration[formData?.eventDuration?.length - 1]?.end
        )
      : null
  );

  // Handle range selection
  const handleDateSelection = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      const days = differenceInCalendarDays(end, start) + 1; // Calculate number of days

      // Reset `eventDuration` to only include the new date range without any previous disabled days
      const duration = Array.from({ length: days }).map((_, index) => {
        const currentDay = addDays(start, index); // Add days iteratively
        // const existingDay = formData.eventDuration?.[index];

        return {
          start: startOfDay(currentDay), // Set time to 12:00 AM
          end: endOfDay(currentDay), // Set time to 11:59 PM
          selected: true,
        };
      });
      setFormData((prev) => ({ ...prev, eventDuration: duration })); // Update formData with eventDuration
      setAllSelected(true);
    }
  };

  const values = {
    registeredEvents,
    setRegisteredEvents,
    meetingAdded,
    setMeetingAdded,
    formData,
    setFormData,
    mainEventFormFilledPercentage,
    setMainEventFormFilledPercentage,
    profileFormFilledPercentage,
    setProfileFormFilledPercentage,
    mainEventID,
    setMainEventID,
    isFormVisible,
    setIsFormVisible,
    handleChange,
    LocationformData,
    setLocationFormData,
    handleLocationChange,
    subEventFormData,
    setSubEventFormData,
    handleSubChange,
    speakerFormData,
    setSpeakerFormData,
    handleSpeakerChange,
    SponsorformData,
    setSponsorFormData,
    handleSponsorChange,
    stallFormData,
    setStallFormData,
    handleStallChange,
    formattedDate,
    formattedTime,
    selectedEvent,
    setSelectedEvent,
    fetchEventDetails,
    loadingEvents,
    eventCreated,
    setEventCreated,
    locationAdded,
    setLocationAdded,
    speakerAdded,
    setSpeakerAdded,
    TypeAdded,
    setTypeAdded,
    sponsorAdded,
    setSponsorAdded,
    stallAdded,
    setStallAdded,
    subEventAdded,
    setSubEventAdded,
    stalls,
    setStalls,
    registrationData,
    setRegistrationData,
    // handleStallEdit,
    stallEditIndex,
    setStallEditIndex,
    subEvents,
    setSubEvents,
    subEventEditIndex,
    setSubEventEditIndex,
    // handleSubEdit,
    loading,
    setLoading,
    isModalOpen,
    setIsModalOpen,
    locations,
    setLocations,
    editIndex,
    setEditIndex,
    types,
    setTypes,
    typeEditIndex,
    setTypeEditIndex,
    // handleTypeEdit,
    registrationFormData,
    setRegistraionFormData,
    handleRegisterChange,
    speakers,
    setSpeakers,
    // handleSpeakerEdit,
    speakerEditIndex,
    setSpeakerEditIndex,
    sponsors,
    setSponsors,
    // handleSponsorEdit,
    sponsorEditIndex,
    setSponsorEditIndex,
    resetForm,
    meetingFormData,
    setMeetingFormData,
    newEvent,
    setNewEvent,
    view,
    setView,
    selectedDate,
    setSelectedDate,
    isSubModalOpen,
    setIsSubModalOpen,
    handleSelectSlot,
    acceptedInvitations,
    setAcceptedInvitations,
    rejectedInvitations,
    setRejectedInvitations,
    selectedUser,
    setSelectedUser,
    handleConnect,
    connStatus,
    setConnStatus,
    fetchConnectionStatus,
    eventDuration,
    setEventDuration,
    allSelected,
    setAllSelected,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleDateSelection,
  };

  return (
    <EventContext.Provider value={values}>{children}</EventContext.Provider>
  );
};
